import React from 'react';
// import React from 'react';
// import PropTypes from 'prop-types';
import SideList from 'partial/wrappers/SideList';
import NavTab, { NavTabItem } from 'partial/components/NavTab';
import { useRouteMatch, Switch, Route, Redirect } from 'react-router-dom';
import ChannelHeader from '../components/ChannelHeader';
import ChannelDetail from '../components/ChannelDetail';
import ChannelList from '../components/ChannelList';
import { useChannelSelected } from '../hooks';
import ChannelBranch from './ChannelBranch';

function ChannelProfile() {
  const renderList = React.useCallback(
    (selected, onSelect) => (
      <ChannelList onSelect={onSelect} selected={selected} />
    ),
    []
  );
  const match = useRouteMatch();
  const [isLoading, data] = useChannelSelected();
  return (
    <SideList id="channel-profile" renderList={renderList}>
      <div className="bg-gray-50 min-h-full flex-grow flex flex-col">
        <ChannelHeader data={data} isLoading={isLoading} />
        <div className="border-b border-gray-200 mb-2">
          <NavTab>
            <NavTabItem to={`${match.url}/details`} label="Details" />
            <NavTabItem to={`${match.url}/branch`} label="Branch" />
          </NavTab>
        </div>
        {data.id ? (
          <div className="mt-6 px-4 pb-8 sm:px-6 lg:px-8 flex-1 flex flex-col">
            <Switch>
              <Route path={`${match.path}/details`}>
                <ChannelDetail data={data} />
              </Route>
              <Route path={`${match.path}/branch`}>
                <ChannelBranch />
              </Route>
              <Redirect to={`${match.url}/details`} />
            </Switch>
          </div>
        ) : null}
      </div>
    </SideList>
  );
}

ChannelProfile.propTypes = {};

export default ChannelProfile;
